<template>
  <div>
    <dialogos-app :dialogos="dialogos"></dialogos-app>
     <div class="text-xs-center">
        <svg-buttons @finished="$store.commit('nextShow', true)"/>
      </div>
      
    <audio-player ref="audioPlayer" :autoplay="true" :audios="[
      'Modulo 3/AUDIO 09'
    ]"></audio-player> 
  </div>
</template>

<script>
import SvgButtons from '../../assets/Modulo 3/diapositiva-9'
export default {
  components:{
    SvgButtons
  },
  data() {
    return {
      dialogos: [
        "Estas son las fortalezas y las debilidades del procedimiento probabilístico. <span class='instruccion'>Haz clic en el esquema.</span>" 
      ],
    }
  },
  created() {
    this.$store.commit('nextShow', false)
  }
}
</script>
<style lang="scss" scoped>
</style>
